module.exports = __webpack_public_path__ + "img/icon-no-files.4000b405.png";